import React, { PropTypes as p } from 'react'
import { Link } from 'react-router'

import omit from 'lodash/omit'
import cx from 'classnames'

export const Button = (props) => {
  if (props.externalUrl) {
    return <a href={props.externalUrl} target='_blank' {...buttonProps(props)}>{props.children}</a>
  } else {
    return <Link {...buttonProps(props)}>{props.children}</Link>
  }
}

Button.propTypes = {
  children: p.node,
  small: p.bool,
  disabled: p.bool
}

export const ButtonRow = (props) => (
  <div className='button-row' {...props}>{props.children}</div>
)

ButtonRow.propTypes = {
  children: p.node
}

export const CollectionButton = ({
  className = '',
  children,
  ...rest
}) => (
  <Button className={`collection-button ${className}`} {...rest}>{children}</Button>
)

function handleClick (props, event) {
  if (props.disabled) {
    event.preventDefault()
  } else {
    props.onClick && props.onClick(event)
  }
}

function buttonProps (props) {
  return {
    className: cx('button', { small: props.small, disabled: props.disabled }),
    ...omit(props, ['small', 'externalUrl']),
    onClick (e) { handleClick(props, e) }
  }
}

export const FilterButton = ({ to, title, children, style, className, renderButton }) => (
  <p className={cx(className)} style={{
    display: 'flex',
    padding: '1px',
    ...style
  }}>
    { renderButton ||
      <Button style={{flex: 1, padding: '3px 5px', marginRight: '5px'}} small to={to}>{title}</Button>
    }
    <span style={{flex: 2, fontSize: '0.8em', alignSelf: 'center'}}>: {children}</span>
  </p>
);



// WEBPACK FOOTER //
// ./src/components/buttons/index.js